import { render, staticRenderFns } from "./microShopAssociation.vue?vue&type=template&id=bed9a4a0&scoped=true&"
import script from "./microShopAssociation.vue?vue&type=script&lang=js&"
export * from "./microShopAssociation.vue?vue&type=script&lang=js&"
import style0 from "./microShopAssociation.vue?vue&type=style&index=0&id=bed9a4a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed9a4a0",
  null
  
)

component.options.__file = "microShopAssociation.vue"
export default component.exports